/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function TagFilledIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="tag-filled"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M10.308 3.969C10.772 3.544 11.495 3.211 12.12 3.136L18.249 2.665C19.061 2.649 19.988 2.983 20.502 3.498C21.017 4.012 21.351 4.939 21.335 5.751L20.864 11.881C20.789 12.506 20.456 13.228 20.031 13.692L12.776 20.947C12.232 21.437 11.41 21.789 10.742 21.789C10.075 21.789 9.253 21.437 8.709 20.947L3.053 15.291C2.563 14.747 2.211 13.925 2.211 13.258C2.211 12.59 2.563 11.768 3.053 11.224L10.308 3.969ZM17.107 5.435C16.301 5.435 15.648 6.088 15.648 6.893C15.648 7.699 16.301 8.352 17.107 8.352C17.912 8.352 18.565 7.699 18.565 6.893C18.565 6.088 17.912 5.435 17.107 5.435Z" data-tinysvg-shape="compound-path" fillRule="evenodd" stroke="none" fill={color} data-fill-tone="primary" />
    </svg>
  )
}
